import lottie from 'lottie-web';
import $ from 'jquery';
import { debounce } from './Helpers/debounce';


/**
 * See https://github.com/airbnb/lottie-web
 */
export class LottieModule {
    constructor() {
        //Dynamic Data icons
        const $set = $("[data-animval]");
        $set.each((idx) => {
            this.runAnimation($($set[idx]));
        });    

        if ($("[data-infoicon]").length) {
            this.animateInfoIcons();
        }
    }

    animateInfoIcons() {
        //Load animation on Scroll  
        const $infoicon = $("[data-infoicon]");
        // sets default value of surrounding div to none so it doesnt appear
        var animationDiv = $('[data-infoicon]')[0];
        animationDiv.style.opacity = 0;
    
        setTimeout(() => { 
            this.inView(animationDiv, $infoicon);
        }, 250);

        // Get the ScrollAreas position in the viewport            
        window.addEventListener('scroll', debounce(() => {    
            this.inView(animationDiv, $infoicon);
        }, 50 ));
    }

    inView(div, icon) {
        var bounding = div.getBoundingClientRect();                
        if (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        ) {
            if (div.style.opacity == 0) {
                div.style.opacity= 1
                icon.each((idx) => {
                    this.runAnimationInfoicon($(icon[idx]));
                }); 

            }; 
        } 
    }

    getAnimation() {
        return {
            container: null,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: null,
            name: 'myAnimation',
            rendererSettings: {
                progressiveLoad:true
            },
        }
    }

    //Dynamic Data icons
    runAnimation($el) {
        const val = $el.data('animval');
        let animationObj = this.getAnimation();

        let basePath = '/wp-content/themes/lynx-hedge/assets/images/data-icons/';
        
        if (val == 'value-up') {
            animationObj.path = basePath + 'Graf-Up.json';
        }
        if (val == 'value-down') {
            animationObj.path = basePath + 'Graf-Down.json';
        }
        if (val == 'value-still') {
            animationObj.path = basePath + 'Graf-Still.json';
        }
        
        animationObj.container = $el.get(0);
        
        setTimeout(() => { 
            lottie.loadAnimation(animationObj);
        }, 500);
    }

    //Info icon
    runAnimationInfoicon($el) {
        const val = $el.data('infoicon');
        let animationObj2 = this.getAnimation();
        let basePath = '/wp-content/themes/lynx-hedge/assets/images/infoblock-icons/'; 
        animationObj2.path = basePath + val + '.json';
        animationObj2.container = $el.get(0);
        
        setTimeout(() => { 
            lottie.loadAnimation(animationObj2);
        }, 250);
    }

}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/LottieModule.js